<template>
  <alert type="loader" color="light" />
</template>
<script>
export default {
  name: "Loading",
};
</script>
